import React, { useEffect, useState } from 'react'
import CustomReportsHeader from './CustomReportsHeader'
import CreateReport from './CreateReport'
import ListOfReports from './ListOfReports'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../../utils/util'

function ManageCustomReports() {
    usePageTitle('Upstrive Education - Custom reports')
    const { t } = useTranslation()
    const [updateList, setUpdateList] = useState(Date.now())

    return (
        <div id="basic-student" className="analytics-container  light-small-scroll bg-[#ECEBF8] max-h-[100vh] overflow-hidden">
            <div className="analytics-inner-container mb-[30px]">
                <CustomReportsHeader title={t('Create & Manage Reports')} />
                <div className="flex flex-row gap-[20px] mt-[30px] flex-1 w-full" style={{ maxHeight: 'calc(100vh - 230px)' }}>
                    <CreateReport
                        updateReportList={() => {
                            setUpdateList(Date.now())
                        }}
                    />
                    <ListOfReports refreshList={updateList} />
                </div>
            </div>
        </div>
    )
}

export default ManageCustomReports
